import {React,useState, useEffect} from "react";
import realtimeDB from "../Utils/api";

const useReservas = () => 
{
  const [Reservas, setReservas] = useState([]);
  useEffect(() => 
  {
    realtimeDB.ref("/Booking/Booking").on("value",snapshot =>
    {
      snapshot.forEach( reservation =>
        {
          if(reservation.val().status==="active")
          {
           
          }
        })
    });
  }, []);


  return Reservas;
}

export default useReservas
